export function cleanNullValuesFromObject(objectToClean) {
  return Object.entries(objectToClean).reduce((prev, [key, value]) => {
    if (value !== '' && value !== null && value !== [] && typeof value !== 'undefined')
      prev[key] = value
    return prev
  }, {})
}

export function checkNestedProperties(objectToCheck, level, ...rest) {
  if (objectToCheck === undefined) return false
  if (rest.length == 0 && objectToCheck.hasOwnProperty(level)) return true
  return checkNestedProperties(objectToCheck[level], ...rest)
}

export function validateRequiredKeys(objectToValidate, requiredKeys) {
  const passedPropKeys = Object.keys(objectToValidate)
  return requiredKeys.every(key => {
    if (key.includes('.')) {
      const nestedKeys = key.split('.')
      return checkNestedProperties(objectToValidate, nestedKeys[0], nestedKeys.slice(1))
    }
    return passedPropKeys.includes(key)
  })
}

/**
 * Funcion recursiva que obtiene el valor de una propiedad anidada dentro de un objeto
 * @param {Object} objectToCheck - Objeto que será evaluado
 * @param {String} level - Primer nivel. Propiedad dentro del objeto. El valor de esta propiedad será retornado.
 * @param  {...any} rest - Resto de niveles anidados. Si estan presentes, activaran la recursividad de la funcion.
 * @returns {any} Valor deseado de la propiedad anidada
 */
export function getNestedPropertyValue(objectToCheck, level, ...rest) {
  if (objectToCheck === undefined)
    throw new Error('getNestedPropertyValue | Property does not exist.')
  if (rest.length == 0 && objectToCheck.hasOwnProperty(level)) return objectToCheck[level]
  return getNestedPropertyValue(objectToCheck[level], ...rest)
}

/**
 * Funcion que busca determinadas 'llaves' (incluso anidadas) en un objeto
 * @param {Object} objectToSearch - Objeto que será evaluado para encontrar las llaves indicadas
 * @param {Array<String>} keysToSearchFor - Llaves que se buscarán dentro del objeto determinado en objectToSearch
 * @param {Boolean} withValues - Determina si el resultado debe contener los valores de las llaves encontradas en el objeto
 * @returns {Array<string>|Object} - Si 'withValues' es falso, el resultado será un listado de las llaves encontradas en el objeto. Si 'withValues' es verdadero, el resultado será un objeto con las llaves y sus respectivos valores encontrados.
 */
export function getFoundKeysOnObject(objectToSearch, keysToSearchFor, withValues = false) {
  let startingValue = withValues ? {} : []
  return keysToSearchFor.reduce((previousValue, currentValue) => {
    try {
      // Si el key incluye un punto, evaluamos una propiedad anidada.
      // Los niveles estarian indicados por los puntos '.'
      const key = currentValue.split('.')
      // Obtenemos del objeto "objectToSearch" el valor de la propiedad
      const value = getNestedPropertyValue(objectToSearch, ...key)
      return withValues
        ? Object.defineProperty(previousValue, key.join('.'), { value, enumerable: true })
        : [...previousValue, key.join('.')]
    } catch (error) {
      if (error.message.startsWith('getNestedPropertyValue')) {
        // Si caemos en este bloque, es porque no existe la propiedad.
        // Entonces continuamos con la iteracion ignorando esta propiedad.
        return previousValue
      }
    }
  }, startingValue)
}

export function getYoutubeThumbnail(url) {
  let match,
    embed,
    thumbUrl = 'http://i3.ytimg.com/vi/'
  // Run passed url through regexp to find matches
  match = url.match(
    /(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/,
  )
  if (!match) return { hq: thumbUrl, maxres: thumbUrl }
  // Obtain embed code through match group
  embed = match[1]
  // Build thumbnail url for this video
  thumbUrl += embed
  // Return max resolution url and hq resolution url
  return {
    maxres: thumbUrl + '/maxresdefault.jpg',
    hq: thumbUrl + '/hqdefault.jpg',
  }
}
